import Typography from '@material-ui/core/Typography';
import { styled } from '@material-ui/core/styles';

export const DateRangeDelimiter = styled(Typography)({
  margin: '0 16px',
});
